'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExecutivesummaryController = function ExecutivesummaryController($scope, Constants, $filter, $rootScope, FunctionService, User) {
    _classCallCheck(this, ExecutivesummaryController);

    var Highcharts = require('highcharts');
    require('highcharts/highcharts-3d')(Highcharts);

    Highcharts.setOptions({
        lang: {
            decimalPoint: '.',
            thousandsSep: ','
        }
    });

    Highcharts.getOptions().colors = Highcharts.map(Highcharts.getOptions().colors, function (color) {
        return Highcharts.Color(color).setOpacity(1).get('rgba');
    });
    this.user = User.getUser();
    this.episodeValue = '';
    this.fixedValue = '';
    this.specialtyString = '';
    this.specialtyStringSentenceCase = '';
    this.showCriteriaSummary = false;
    this.title = '';
    this.byMonthHeading = '';
    this.bySpecialtyHeading = '';
    this.criteriaSummaryHeading = 'Criteria Breakdown Summary';
    this.auditTypeSummaryHeading = 'Audit Type Summary';
    this.functionSettings = {};

    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
        $scope.vm.functionSettings = response.functionSettings;
        $scope.vm.episodeValue = response.functionSettings.EpisodeValue && response.functionSettings.EpisodeValue.valueString ? response.functionSettings.EpisodeValue.valueString : 'WIES';
        $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
        $scope.vm.specialtyStringSentenceCase = $scope.vm.specialtyString.charAt(0).toUpperCase() + $scope.vm.specialtyString.slice(1).toLowerCase();
        var selectedYearType = response.functionSettings.CalendarOrFinancialYearReporting && response.functionSettings.CalendarOrFinancialYearReporting.valueString ? response.functionSettings.CalendarOrFinancialYearReporting.valueString : 'Financial';
        $scope.vm.yearTypeSelected = selectedYearType + ' Year';
        if (selectedYearType === 'Calendar') {
            $scope.vm.yearOptions = $scope.vm.calYearOptions;
            $scope.vm.yearSelected = $scope.vm.calYearOptions[0];
        } else {
            $scope.vm.yearOptions = $scope.vm.finYearOptions;
            $scope.vm.yearSelected = $scope.vm.finYearOptions[0];
        }
        $scope.vm.fixedValue = $scope.vm.episodeValue === '$' ? 2 : 4;
        if (response.functionSettings.CriteriaSummary && response.functionSettings.CriteriaSummary.isActive) {
            $scope.vm.showCriteriaSummary = true;
        }
        $scope.vm.title = response.functionSettings.ExecutiveSummaryTitle.valueString;
        $scope.vm.byMonthHeading = 'Overall Audit DRG and ' + $scope.vm.episodeValue + ' Achievement';
        $scope.vm.bySpecialtyHeading = 'Unit DRG and ' + $scope.vm.episodeValue + ' Audit Results';
        $scope.vm.excludedSpecialties = response.functionSettings.ExcludedSpecialties.valueString ? response.functionSettings.ExcludedSpecialties.valueString.replace(/\|/g, ', ') : '';
        $scope.vm.excludedPatientClasses = response.functionSettings.ExcludedPatientClassifications.valueString ? response.functionSettings.ExcludedPatientClassifications.valueString.replace(/\|/g, ', ') : '';
        //Initalise the tables after we get the episode value type
        drawByMonthDt();
        drawBySpecialtyDt();
        if ($scope.vm.showCriteriaSummary) {
            drawCriteriaSummaryDt();
        };
        drawAuditTypeSummaryDt();

        Constants.campusData().then(function successCallback(response) {
            if ($scope.vm.user.role !== 'Administrator' && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
                var campusOptions = [];
                if (typeof $scope.vm.user.campus === 'string') {
                    campusOptions = unescape($scope.vm.user.campus).split(','); // tslint:disable-line
                } else {
                    campusOptions = unescape($scope.vm.user.campus.join()).split(','); // tslint:disable-line
                }
                $scope.vm.campusOptions = campusOptions;
                $scope.vm.campusSelected = campusOptions.length > 0 ? campusOptions[0] : '';
            } else {
                $scope.vm.campusOptions = response;
            }
        });
    });

    this.byMonthDt;
    this.bySpecialtyDt;
    this.criteriaSummaryDt;
    this.auditTypeSummaryDt;
    this.byMonthDtInitComplete = byMonthDtInitComplete;
    this.bySpecialtyDtInitComplete = bySpecialtyDtInitComplete;
    this.criteriaSummaryDtInitComplete = criteriaSummaryDtInitComplete;
    this.auditTypeSummaryDtInitComplete = auditTypeSummaryDtInitComplete;
    this.bySpecialtyDtRowCallback = bySpecialtyDtRowCallback;
    this.byMonthDtDrawCallback = byMonthDtDrawCallback;
    this.bySpecialtyDtDrawCallback = bySpecialtyDtDrawCallback;

    this.printByMonthDt = true;
    this.printBySpecialtyDt = true;
    this.printCriteriaSummaryDt = true;
    this.printAuditTypeSummaryDt = true;
    this.printWiesByMonthTable = true;
    this.printWiesByMonthChart = true;
    this.printWiesBySpecialtyTable = true;
    this.printWiesBySpecialtyChart = true;

    this.yearOptions = [];
    this.finYearOptions = [];
    this.calYearOptions = [];
    this.yearSelected = undefined;

    this.yearTypeOptions = ['Financial Year', 'Calendar Year'];
    this.yearTypeSelected = undefined;

    this.monthOptions = [];
    this.monthSelected = undefined;

    this.campusOptions = [];
    this.campusSelected = undefined;

    this.divisionOptions = [];
    this.divisionSelected = undefined;

    this.byMonthDtColsOptions = [];
    this.byMonthDtColsSelected = [];

    this.bySpecialtyDtColsOptions = [];
    this.bySpecialtyDtColsSelected = [];

    this.criteriaSummaryDtColsOptions = [];
    this.criteriaSummaryDtColsSelected = [];

    this.auditTypeSummaryDtColsOptions = [];
    this.auditTypeSummaryDtColsSelected = [];

    this.currentMonth = moment().format('MM');
    this.currentYear = moment().format('YYYY');
    this.currentDate = moment().format('DD/MM/YYYY');
    this.startDate = moment($scope.vm.currentMonth + '/' + $scope.vm.currentYear, 'MM/YYYY').startOf('month').format('DD/MM/YYYY');
    this.startDateDisplay = moment($scope.vm.startDate, 'DD/MM/YYYY').format('DD MMMM YYYY');
    this.endDate = moment($scope.vm.currentMonth + '/' + $scope.vm.currentYear, 'MM/YYYY').endOf('month').format('DD/MM/YYYY');
    this.endDateDisplay = moment($scope.vm.endDate, 'DD/MM/YYYY').format('DD MMMM YYYY');

    this.setYearType = setYearType;
    this.setYear = setYear;
    this.setMonth = setMonth;
    this.setDates = setDates;

    Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
        $scope.vm.divisionOptions = response.divisions;
    });

    this.url = WEBSERVICEURL + '/dataagility/api/service.executivesummary/query';
    this.byMonthDtUrl = $scope.vm.url + '?tableFlag=0' + '&startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam($scope.vm.campusSelected) + '&division=' + encodeParam($scope.vm.divisionSelected);
    this.bySpecialtyDtUrl = $scope.vm.url + '?tableFlag=1' + '&startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam($scope.vm.campusSelected) + '&division=' + encodeParam($scope.vm.divisionSelected);
    this.criteriaSummaryDtUrl = $scope.vm.url + '?tableFlag=2' + '&startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam($scope.vm.campusSelected) + '&division=' + encodeParam($scope.vm.divisionSelected);
    this.auditTypeSummaryDtUrl = $scope.vm.url + '?tableFlag=3' + '&startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam($scope.vm.campusSelected) + '&division=' + encodeParam($scope.vm.divisionSelected);

    this.changeData = changeData;
    this.printPage = printPage;
    this.togglePrint = togglePrint;
    this.toggleColumns = toggleColumns;

    // Hide the tables and charts until they have data
    $('#table__wiesByMonth, #chart__wiesByMonth').hide();
    $('#table__wiesBySpecialty, #chart__wiesBySpecialty').hide();

    // Initialise select values
    initFinYear();
    initMonth();
    initCalendarYearOptions();

    // Draw the by month table
    function drawByMonthDt() {
        $scope.vm.byMonthDt = $('#byMonthDt').DataTable({
            ajax: {
                url: $scope.vm.byMonthDtUrl,
                headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
                dataSrc: "", // Required so that DataTables expects an array instead of an object
                type: "GET",
                error: function error(xhr, _error, thrown) {
                    if (thrown == 'Unauthorized') {
                        //window.location.replace(window.location.origin + '/login');
                        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
                    }
                }
            },
            initComplete: $scope.vm.byMonthDtInitComplete,
            drawCallback: $scope.vm.byMonthDtDrawCallback,
            bFilter: false,
            bInfo: false,
            paging: false,
            ordering: false,
            columns: [{
                data: "dischargeMonth",
                className: "mdl-data-table__cell--non-numeric"
            }, { data: "episodes" }, { data: "episodesRequiringAudit" }, { data: "episodesRequiringAuditPC" }, { data: "episodesAudited" }, { data: "episodesAuditedPC" }, { data: "episodesToBeAudited" }, { data: "episodesToBeAuditedPC" }, { data: "queriesGenerated" }, { data: "queriesAwaitingReview" }, { data: "codingChanges" }, { data: "drgChanges" }, { data: "drgChangesPC" }, { data: "wiesChange" }, { data: "wies" }, { data: "wiesTarget" }, { data: "wiesVariance" }],
            columnDefs: [{
                render: function render(data, type, row, meta) {
                    return data.toFixed(2);
                },
                targets: [3, 5, 7, 12]
            }, {
                render: function render(data, type, row, meta) {
                    return data ? data.toFixed($scope.vm.fixedValue) : '0.00';
                },
                targets: [13, 14]
            }]
        });
    };

    // Draw the by specialty table
    function drawBySpecialtyDt() {
        $scope.vm.bySpecialtyDt = $('#bySpecialtyDt').DataTable({
            ajax: {
                url: $scope.vm.bySpecialtyDtUrl,
                headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
                dataSrc: "", // Required so that DataTables expects an array instead of an object
                type: "GET",
                error: function error(xhr, _error2, thrown) {
                    if (thrown == 'Unauthorized') {
                        //window.location.replace(window.location.origin + '/login');
                        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
                    }
                }
            },
            initComplete: $scope.vm.bySpecialtyDtInitComplete,
            rowCallback: $scope.vm.bySpecialtyDtRowCallback,
            drawCallback: $scope.vm.bySpecialtyDtDrawCallback,
            bFilter: false,
            bInfo: false,
            paging: false,
            ordering: false,
            columns: [{ data: "division" }, {
                data: "speciality",
                className: "mdl-data-table__cell--non-numeric"
            }, { data: "episodes" }, { data: "episodesRequiringAudit" }, { data: "episodesRequiringAuditPC" }, { data: "episodesAudited" }, { data: "episodesAuditedPC" }, { data: "episodesToBeAudited" }, { data: "episodesToBeAuditedPC" }, { data: "queriesGenerated" }, { data: "queriesAwaitingReview" }, { data: "codingChanges" }, { data: "drgChanges" }, { data: "drgChangesPC" }, { data: "wiesChange" }, { data: "wies" }, { data: "complexityIndex" }],
            columnDefs: [{ visible: false, targets: 0 }, {
                render: function render(data, type, row, meta) {
                    return data.toFixed(2);
                },
                targets: [4, 6, 8, 13, 16]
            }, {
                render: function render(data, type, row, meta) {
                    return data.toFixed($scope.vm.fixedValue);
                },
                targets: [14, 15]
            }]
        });
    };

    // Draw the criteria summary table
    function drawCriteriaSummaryDt() {
        $scope.vm.criteriaSummaryDt = $('#criteriaSummaryDt').DataTable({
            ajax: {
                url: $scope.vm.criteriaSummaryDtUrl,
                headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
                dataSrc: "", // Required so that DataTables expects an array instead of an object
                type: "GET",
                error: function error(xhr, _error3, thrown) {
                    if (thrown == 'Unauthorized') {
                        //window.location.replace(window.location.origin + '/login');
                        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
                    }
                }
            },
            initComplete: $scope.vm.criteriaSummaryDtInitComplete,
            rowCallback: $scope.vm.criteriaSummaryDtRowCallback,
            bFilter: false,
            bInfo: false,
            paging: false,
            ordering: false,
            columns: [{
                data: "groupName",
                className: "mdl-data-table__cell--non-numeric"
            }, { data: "doesNotMeetCriteria" }, { data: "doesNotMeetCriteriaPC" }, { data: "originalCoderQuery" }, { data: "originalCoderQueryPC" }, { data: "targetDRG" }, { data: "targetDRGPC" }, { data: "borCDRG" }, { data: "borCDRGPC" }, { data: "other" }, { data: "otherPC" }, { data: "total" }],
            columnDefs: [{
                render: function render(data, type, row, meta) {
                    return data.toFixed(2);
                },
                targets: [2, 4, 6, 8, 10]
            }]
        });
    };

    // Draw the audit type summary table
    function drawAuditTypeSummaryDt() {
        $scope.vm.auditTypeSummaryDt = $('#auditTypeSummaryDt').DataTable({
            ajax: {
                url: $scope.vm.auditTypeSummaryDtUrl,
                headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
                dataSrc: "", // Required so that DataTables expects an array instead of an object
                type: "GET",
                error: function error(xhr, _error4, thrown) {
                    if (thrown == 'Unauthorized') {
                        //window.location.replace(window.location.origin + '/login');
                        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
                    }
                }
            },
            initComplete: $scope.vm.auditTypeSummaryDtInitComplete,
            rowCallback: $scope.vm.auditTypeSummaryDtRowCallback,
            bFilter: false,
            bInfo: false,
            paging: false,
            ordering: false,
            columns: [{
                data: "auditType",
                className: "mdl-data-table__cell--non-numeric"
            }, { data: "flagged" }, { data: "audited" }, { data: "percentAudited" }, { data: "changed" }, { data: "percentChanged" }, { data: "wiesDifference" }],
            columnDefs: [{
                render: function render(data, type, row, meta) {
                    return data.toFixed(2);
                },
                targets: [3, 5]
            }, {
                render: function render(data, type, row, meta) {
                    return parseFloat(data).toFixed($scope.vm.fixedValue);
                },
                targets: [6]
            }]
        });
    };

    // Show loading message on tables during new ajax call
    $('#byMonthDt, #bySpecialtyDt, #criteriaSummaryDt, #auditTypeSummaryDt').on('preXhr.dt', function (e, settings, data) {
        $(this).dataTable().api().clear();
        settings.iDraw = 0; // 0 means "initial draw", which, after clearing table, will show "Loading..." again
        $(this).dataTable().api().draw();
    });

    // Initialise financial year select values
    function initFinYear() {
        if (moment().month() < 6) {
            var year = moment().format('YYYY');
        } else {
            var year = moment().add(1, 'year').format('YYYY');
        }

        for (var i = 0; i < 10; i++) {
            $scope.vm.finYearOptions.push(year - 1 + ' - ' + year);
            year--;
        }
    }

    function initCalendarYearOptions() {
        var year = moment().format('YYYY');
        for (var i = 0; i < 10; i++) {
            $scope.vm.calYearOptions.push(year);
            year--;
        }
    }

    // Initialise month select values
    function initMonth() {
        var months = [];

        // Order the months in the dropdown from July to June,
        // starting with Jul to Dec
        for (var i = 6; i < 12; i++) {
            months.push(moment.months(i));
        }

        // Then Jan to Jun
        for (var i = 0; i < 6; i++) {
            months.push(moment.months(i));
        }

        $scope.vm.monthOptions = months;
        // Stick 'All months' at the top
        $scope.vm.monthOptions.unshift('All months');
        // Default to current month
        $scope.vm.monthSelected = moment().format('MMMM');
    }

    function byMonthDtInitComplete(settings, json) {
        // Get the list of columns for the show/hide select
        $("#byMonthDt thead tr th").each(function () {
            $scope.vm.byMonthDtColsOptions.push(this.innerHTML);
            $scope.vm.byMonthDtColsSelected.push(this.innerHTML);
        });
    }

    function bySpecialtyDtInitComplete(settings, json) {
        // Get the list of columns for the show/hide select
        $("#bySpecialtyDt thead tr th").each(function () {
            $scope.vm.bySpecialtyDtColsOptions.push(this.innerHTML);
            $scope.vm.bySpecialtyDtColsSelected.push(this.innerHTML);
        });
    }

    function criteriaSummaryDtInitComplete(settings, json) {
        // Get the list of columns for the show/hide select
        $("#criteriaSummaryDt thead tr th").each(function () {
            $scope.vm.criteriaSummaryDtColsOptions.push(this.innerHTML.replace(/<br>/g, ' '));
            $scope.vm.criteriaSummaryDtColsSelected.push(this.innerHTML.replace(/<br>/g, ' '));
        });
    }

    function auditTypeSummaryDtInitComplete(settings, json) {
        // Get the list of columns for the show/hide select
        $("#auditTypeSummaryDt thead tr th").each(function () {
            $scope.vm.auditTypeSummaryDtColsOptions.push(this.innerHTML.replace(/<br>/g, ' '));
            $scope.vm.auditTypeSummaryDtColsSelected.push(this.innerHTML.replace(/<br>/g, ' '));
        });
    }

    function bySpecialtyDtRowCallback(row, data, index) {
        // Shade cells to highlight number of outstanding queries
        if (data.queriesAwaitingReview > 50) {
            $(row).find('td:eq(9)').addClass('bgc-red-500 tc-white bt-white');
        } else if (data.queriesAwaitingReview > 29) {
            $(row).find('td:eq(9)').addClass('bgc-orange-500 tc-white bt-white');
        } else {
            $(row).find('td:eq(9)').addClass('bgc-green-500 tc-white bt-white');
        }
    }

    function byMonthDtDrawCallback(settings) {

        function sum(a, b) {
            return a + b;
        }

        var api = this.api(),
            rows = api.rows().nodes(),

        // Calculate totals for footer
        episodesTotal = api.column(1).data().reduce(sum, 0),
            episodesRequiringAuditTotal = api.column(2).data().reduce(sum, 0),
            episodesRequiringAuditPcTotal = episodesRequiringAuditTotal / episodesTotal * 100,
            episodesAuditedTotal = api.column(4).data().reduce(sum, 0),
            episodesAuditedPcTotal = episodesAuditedTotal / episodesRequiringAuditTotal * 100,
            episodesToBeAuditedTotal = api.column(6).data().reduce(sum, 0),
            episodesToBeAuditedPcTotal = episodesToBeAuditedTotal / episodesRequiringAuditTotal * 100,
            queriesGeneratedTotal = api.column(8).data().reduce(sum, 0),
            queriesAwaitingReviewTotal = api.column(9).data().reduce(sum, 0),
            codingChangesTotal = api.column(10).data().reduce(sum, 0),
            drgChangesTotal = api.column(11).data().reduce(sum, 0),
            drgChangesPcTotal = drgChangesTotal / episodesAuditedTotal * 100,
            wiesChangeTotal = api.column(13).data().reduce(sum, 0),
            wiesTotal = api.column(14).data().reduce(sum, 0),
            wiesTargetTotal = api.column(15).data().reduce(sum, 0),
            wiesVarianceTotal = api.column(16).data().reduce(sum, 0);

        $(rows).eq(api.column(0).data().length - 1).after('<tr class="group-footer">' + '<td class="mdl-data-table__cell--non-numeric">Total</td>' + '<td>' + episodesTotal + '</td>' + '<td>' + episodesRequiringAuditTotal + '</td>' + '<td>' + (isNaN(parseFloat(episodesRequiringAuditPcTotal).toFixed(2)) ? '0.00' : parseFloat(episodesRequiringAuditPcTotal).toFixed(2)) + '</td>' + '<td>' + episodesAuditedTotal + '</td>' + '<td>' + (isNaN(parseFloat(episodesAuditedPcTotal).toFixed(2)) ? '0.00' : parseFloat(episodesAuditedPcTotal).toFixed(2)) + '</td>' + '<td>' + episodesToBeAuditedTotal + '</td>' + '<td>' + (isNaN(parseFloat(episodesToBeAuditedPcTotal).toFixed(2)) ? '0.00' : parseFloat(episodesToBeAuditedPcTotal).toFixed(2)) + '</td>' + '<td>' + queriesGeneratedTotal + '</td>' + '<td>' + queriesAwaitingReviewTotal + '</td>' + '<td>' + codingChangesTotal + '</td>' + '<td>' + drgChangesTotal + '</td>' + '<td>' + (!isFinite(parseFloat(drgChangesPcTotal).toFixed(2)) ? '0.00' : parseFloat(drgChangesPcTotal).toFixed(2)) + '</td>' + '<td>' + parseFloat(wiesChangeTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + parseFloat(wiesTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + wiesTargetTotal + '</td>' + '<td>' + wiesVarianceTotal + '</td>' + '</tr>');

        // If columns were hidden while the table was empty, we need to hide the footer cells here
        toggleColumns('byMonthDt');
    }

    function bySpecialtyDtDrawCallback(settings) {

        var api = this.api(),
            rows = api.rows().nodes(),
            cellData = null,
            division = null,
            lastDivision = null,

        // Totals
        episodesTotal = 0,
            episodesRequiringAuditTotal = 0,
            episodesAuditedTotal = 0,
            episodesToBeAuditedTotal = 0,
            queriesGeneratedTotal = 0,
            queriesAwaitingReviewTotal = 0,
            codingChangesTotal = 0,
            drgChangesTotal = 0,
            wiesChangeTotal = 0,
            wiesTotal = 0,

        // Grand totals
        episodesGrandTotal = 0,
            episodesRequiringAuditGrandTotal = 0,
            episodesAuditedGrandTotal = 0,
            episodesToBeAuditedGrandTotal = 0,
            queriesGeneratedGrandTotal = 0,
            queriesAwaitingReviewGrandTotal = 0,
            codingChangesGrandTotal = 0,
            drgChangesGrandTotal = 0,
            wiesChangeGrandTotal = 0,
            wiesGrandTotal = 0;

        // Iterate through the division names in the first column (which is hidden)
        api.column(0).data().each(function (division, i) {

            cellData = api.row(api.row($(rows).eq(i)).index()).data();

            // If the division name's missing, make it explicit
            if (division === '' || division === null) {
                division = 'No division assigned';
            }

            // First division group header
            if (lastDivision === null) {
                $(rows).eq(i).before('<tr class="group-header"><td colspan="15" class="mdl-data-table__cell--non-numeric">' + division + '</td></tr>');
            }

            // All group footers but the last one, and all group headers but the first one
            if (lastDivision && lastDivision !== division) {
                $(rows).eq(i).before('<tr class="group-footer">' + '<td class="mdl-data-table__cell--non-numeric">Total</td>' + '<td>' + episodesTotal + '</td>' + '<td>' + episodesRequiringAuditTotal + '</td>' + '<td>' + (episodesTotal ? parseFloat(episodesRequiringAuditTotal / episodesTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + episodesAuditedTotal + '</td>' + '<td>' + (episodesRequiringAuditTotal ? parseFloat(episodesAuditedTotal / episodesRequiringAuditTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + episodesToBeAuditedTotal + '</td>' + '<td>' + (episodesRequiringAuditTotal ? parseFloat(episodesToBeAuditedTotal / episodesRequiringAuditTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + queriesGeneratedTotal + '</td>' + '<td>' + queriesAwaitingReviewTotal + '</td>' + '<td>' + codingChangesTotal + '</td>' + '<td>' + drgChangesTotal + '</td>' + '<td>' + (episodesAuditedTotal ? parseFloat(drgChangesTotal / episodesAuditedTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + parseFloat(wiesChangeTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + parseFloat(wiesTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + (episodesTotal ? parseFloat(wiesTotal / episodesTotal) : 0).toFixed(2) + '</td>' + '</tr>' + '<tr class="group-header"><td colspan="15" class="mdl-data-table__cell--non-numeric">' + division + '</td></tr>');

                // We've reached the start of a new group, so start the totals again
                episodesTotal = cellData.episodes;
                episodesRequiringAuditTotal = cellData.episodesRequiringAudit;
                episodesAuditedTotal = cellData.episodesAudited;
                episodesToBeAuditedTotal = cellData.episodesToBeAudited;
                queriesGeneratedTotal = cellData.queriesGenerated;
                queriesAwaitingReviewTotal = cellData.queriesAwaitingReview;
                codingChangesTotal = cellData.codingChanges;
                drgChangesTotal = cellData.drgChanges;
                wiesChangeTotal = cellData.wiesChange;
                wiesTotal = cellData.wies;
            } else {
                // We haven't reached the start of a new group, so keep adding to the totals
                episodesTotal += cellData.episodes;
                episodesRequiringAuditTotal += cellData.episodesRequiringAudit;
                episodesAuditedTotal += cellData.episodesAudited;
                episodesToBeAuditedTotal += cellData.episodesToBeAudited;
                queriesGeneratedTotal += cellData.queriesGenerated;
                queriesAwaitingReviewTotal += cellData.queriesAwaitingReview;
                codingChangesTotal += cellData.codingChanges;
                drgChangesTotal += cellData.drgChanges;
                wiesChangeTotal += cellData.wiesChange;
                wiesTotal += cellData.wies;
            }

            // Always add to the grand totals
            episodesGrandTotal += cellData.episodes;
            episodesRequiringAuditGrandTotal += cellData.episodesRequiringAudit;
            episodesAuditedGrandTotal += cellData.episodesAudited;
            episodesToBeAuditedGrandTotal += cellData.episodesToBeAudited;
            queriesGeneratedGrandTotal += cellData.queriesGenerated;
            queriesAwaitingReviewGrandTotal += cellData.queriesAwaitingReview;
            codingChangesGrandTotal += cellData.codingChanges;
            drgChangesGrandTotal += cellData.drgChanges;
            wiesChangeGrandTotal += cellData.wiesChange;
            wiesGrandTotal += cellData.wies;

            // We've reached the final row, so add the last group footer and table footer
            if (i === api.column(0).data().length - 1) {
                $(rows).eq(i).after('<tr class="group-footer">' + '<td class="mdl-data-table__cell--non-numeric">Total</td>' + '<td>' + episodesTotal + '</td>' + '<td>' + episodesRequiringAuditTotal + '</td>' + '<td>' + (episodesTotal ? parseFloat(episodesRequiringAuditTotal / episodesTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + episodesAuditedTotal + '</td>' + '<td>' + (episodesRequiringAuditTotal ? parseFloat(episodesAuditedTotal / episodesRequiringAuditTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + episodesToBeAuditedTotal + '</td>' + '<td>' + (episodesRequiringAuditTotal ? parseFloat(episodesToBeAuditedTotal / episodesRequiringAuditTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + queriesGeneratedTotal + '</td>' + '<td>' + queriesAwaitingReviewTotal + '</td>' + '<td>' + codingChangesTotal + '</td>' + '<td>' + drgChangesTotal + '</td>' + '<td>' + (episodesAuditedTotal ? parseFloat(drgChangesTotal / episodesAuditedTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + parseFloat(wiesChangeTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + parseFloat(wiesTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + (episodesTotal ? parseFloat(wiesTotal / episodesTotal) : 0).toFixed(2) + '</td>' + '</tr>' + '<tr class="grand-footer">' + '<td class="mdl-data-table__cell--non-numeric">Grand total</td>' + '<td>' + episodesGrandTotal + '</td>' + '<td>' + episodesRequiringAuditGrandTotal + '</td>' + '<td>' + (episodesGrandTotal ? parseFloat(episodesRequiringAuditGrandTotal / episodesGrandTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + episodesAuditedGrandTotal + '</td>' + '<td>' + (episodesRequiringAuditGrandTotal ? parseFloat(episodesAuditedGrandTotal / episodesRequiringAuditGrandTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + episodesToBeAuditedGrandTotal + '</td>' + '<td>' + (episodesRequiringAuditGrandTotal ? parseFloat(episodesToBeAuditedGrandTotal / episodesRequiringAuditGrandTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + queriesGeneratedGrandTotal + '</td>' + '<td>' + queriesAwaitingReviewGrandTotal + '</td>' + '<td>' + codingChangesGrandTotal + '</td>' + '<td>' + drgChangesGrandTotal + '</td>' + '<td>' + (episodesAuditedGrandTotal ? parseFloat(drgChangesGrandTotal / episodesAuditedGrandTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + parseFloat(wiesChangeGrandTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + parseFloat(wiesGrandTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + (episodesGrandTotal ? parseFloat(wiesGrandTotal / episodesGrandTotal) : 0).toFixed(2) + '</td>' + '</tr>');
            }

            lastDivision = division;
        });

        // If columns were hidden while the table was empty, we need to hide the footer cells here
        toggleColumns('bySpecialtyDt');
    }

    // Redo the wiesByMonth table and chart whenever the corresponding datatable is redrawn
    $('#byMonthDt').on('xhr.dt', function (e, settings, json, xhr) {

        function sum(a, b) {
            return a + b;
        }

        var tableWiesByMonth = $('.table-chart__wiesByMonth tbody'),
            series = [],
            months = [],
            target = [],
            variance = [],
            originalWies = [],
            actualWies = [],
            totalRetrieved = [];

        tableWiesByMonth.empty();

        angular.forEach(json, function (value, key) {

            var month = value.dischargeMonth;

            months.push(month);

            var varianceClass = value.wiesVariance < 0 ? "tc-red-500" : "tc-green-500";
            var original = value.originalWies ? parseFloat(value.originalWies).toFixed($scope.vm.fixedValue) : parseFloat(0).toFixed($scope.vm.fixedValue);
            var retrieved = value.wiesChange ? parseFloat(value.wiesChange).toFixed($scope.vm.fixedValue) : parseFloat(0).toFixed($scope.vm.fixedValue);

            tableWiesByMonth.append('<tr><td class="mdl-data-table__cell--non-numeric">' + month + '</td><td class="mdl-data-table__cell">' + original + '</td><td class="mdl-data-table__cell">' + parseFloat(value.currentWies).toFixed($scope.vm.fixedValue) + '</td><td class="mdl-data-table__cell">' + retrieved + '</td><td class="mdl-data-table__cell">' + value.wiesTarget + '</td><td class="mdl-data-table__cell ' + varianceClass + '"">' + value.wiesVariance + '</td></tr>');

            target.push(value.wiesTarget);
            originalWies.push(value.originalWies);
            actualWies.push(value.currentWies);
            totalRetrieved.push(parseInt(retrieved));
        });

        // If the array's empty, appending to the table will throw an error
        if ($scope.vm.episodeValue === '$' && totalRetrieved.length || $scope.vm.episodeValue !== '$' && actualWies.length) {

            tableWiesByMonth.append('<tr class="oa-footer"><td colspan="2" class="mdl-data-table__cell--non-numeric">Total ' + $scope.vm.episodeValue + ' retrieved</td><td class="mdl-data-table__cell" class="mdl-data-table__cell">' + ($scope.vm.episodeValue === '$' ? '' : parseFloat(actualWies.reduce(sum, 0)).toFixed($scope.vm.fixedValue)) + '</td><td>' + ($scope.vm.episodeValue === '$' ? parseFloat(totalRetrieved.reduce(sum, 0)).toFixed($scope.vm.fixedValue) : '') + '</td><td></td><td></td></tr>');

            // If the array's empty, we have no data, so don't display the tables or charts
            $('#table__wiesByMonth, #chart__wiesByMonth').show();
            $('#table__wiesBySpecialty, #chart__wiesBySpecialty').show();
        }

        Highcharts.chart('chart__wiesByMonth', {
            chart: {
                type: 'bar',
                width: 1000,
                options3d: {
                    enabled: false
                }
            },
            title: {
                text: ''
            },
            legend: {
                enabled: $scope.vm.episodeValue !== '$'
            },
            xAxis: {
                categories: months
            },
            yAxis: {
                title: {
                    enabled: false
                }
            },
            plotOptions: {
                bar: {
                    grouping: true
                    // grouping: false,
                    // depth: 1,
                    // borderWidth: 5,
                }
            },
            series: [{
                name: 'Target ' + $scope.vm.episodeValue,
                type: 'spline',
                data: target,
                color: 'rgba(233, 30, 99, 1)',
                tooltip: {
                    pointFormat: 'Target ' + $scope.vm.episodeValue + ': {point.y:,.0f}'
                },
                zIndex: 1
            }, {
                name: 'Original ' + $scope.vm.episodeValue,
                visible: $scope.vm.episodeValue !== '$',
                data: originalWies,
                // pointPadding: 0.2,
                pointPadding: 0,
                color: 'rgba(33, 150, 243, 1)',
                tooltip: {
                    pointFormat: 'Original ' + $scope.vm.episodeValue + ': {point.y:,.0f}'
                }
            }, {
                name: 'Actual ' + $scope.vm.episodeValue,
                visible: $scope.vm.episodeValue !== '$',
                data: actualWies,
                // pointPadding: 0.1,
                pointPadding: 0,
                color: 'rgba(67, 67, 72, 1)',
                tooltip: {
                    pointFormat: 'Actual ' + $scope.vm.episodeValue + ': {point.y:,.0f}'
                }
            }, {
                name: 'Retrieved ' + $scope.vm.episodeValue,
                visible: $scope.vm.episodeValue === '$',
                data: totalRetrieved,
                pointPadding: 0,
                color: 'rgba(33, 150, 243, 1)',
                tooltip: {
                    pointFormat: 'Retrieved ' + $scope.vm.episodeValue + ': {point.y:,.0f}'
                }
            }]
        });
    });

    // Redo the wiesBySpecialty table and chart whenever the corresponding datatable is redrawn
    $('#bySpecialtyDt').on('xhr.dt', function (e, settings, json, xhr) {
        var tableWiesBySpecialty = $('.table-chart__wiesBySpecialty tbody'),
            series = [],
            otherSpecialties = 0,
            otherWiesChange = 0;

        tableWiesBySpecialty.empty();

        // Sort data by WIES change
        var jsonSorted = $filter('orderBy')(json, 'wiesChange', true);

        angular.forEach(jsonSorted, function (value, key) {

            // Explicitly show the top 10 specialties
            if (key < 10) {
                tableWiesBySpecialty.append('<tr><td class="mdl-data-table__cell--non-numeric">' + value.speciality + '</td><td class="mdl-data-table__cell">' + parseFloat(value.wiesChange).toFixed($scope.vm.fixedValue) + '</td></tr>');

                series.push({ 'name': value.speciality, 'y': value.wiesChange });
            } else {
                otherWiesChange += value.wiesChange;
                otherSpecialties++;
            }
        });

        // Group the rest of the specialties together
        tableWiesBySpecialty.append('<tr><td class="mdl-data-table__cell--non-numeric">Other (' + otherSpecialties + ')</td><td class="mdl-data-table__cell">' + parseFloat(otherWiesChange).toFixed($scope.vm.fixedValue) + '</td></tr>');

        series.push({ 'name': 'Other (' + otherSpecialties + ')', 'y': otherWiesChange });

        Highcharts.chart('chart__wiesBySpecialty', {
            chart: {
                type: 'pie',
                width: 1000
            },
            title: {
                text: ''
            },
            colors: ['#2196f3', '#434348', '#8bc34a', '#ff9800', '#7f84e9', '#9c27b0', '#e91e63', '#ffeb3b', '#009688', '#f44336', '#795548'],
            tooltip: {
                pointFormat: '<b>{point.percentage:.4f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    depth: 25,
                    dataLabels: {
                        enabled: true
                    },
                    size: '100%'
                }
            },
            series: [{
                type: 'pie',
                data: series
            }]
        });
    });

    function encodeParam(param) {
        return encodeURIComponent(param === undefined ? '' : param);
    }

    // Update HTTP request URL and request new data
    function changeData() {
        var campus = '';
        if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
            if ($scope.vm.user.role !== 'Administrator' && $scope.vm.campusSelected.length === 0) {
                campus = $scope.vm.user.campus;
            } else {
                campus = $scope.vm.campusSelected;
            }
        } else {
            campus = $scope.vm.campusSelected;
        }

        var newUrl = $scope.vm.url + '?startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam(campus) + '&division=' + encodeParam($scope.vm.divisionSelected);

        // Hide the current tables and charts until they have new data
        $('#table__wiesByMonth, #chart__wiesByMonth').hide();
        $('#table__wiesBySpecialty, #chart__wiesBySpecialty').hide();

        $scope.vm.byMonthDt.ajax.url(newUrl + '&tableFlag=0').load();
        $scope.vm.bySpecialtyDt.ajax.url(newUrl + '&tableFlag=1').load();
        if ($scope.vm.showCriteriaSummary) {
            $scope.vm.criteriaSummaryDt.ajax.url(newUrl + '&tableFlag=2').load();
        }
        $scope.vm.auditTypeSummaryDt.ajax.url(newUrl + '&tableFlag=3').load();
    }

    // Format year value from select list
    function setYearType(newValue, oldValue) {
        var year = '';
        if (newValue === 'Financial Year') {
            $scope.vm.yearOptions = $scope.vm.finYearOptions;
            $scope.vm.yearSelected = $scope.vm.finYearOptions[0];
            year = newValue.substring(7, 11);
        } else {
            $scope.vm.yearOptions = $scope.vm.calYearOptions;
            $scope.vm.yearSelected = $scope.vm.calYearOptions[0];
            year = newValue;
        }

        if (oldValue) {
            setDates($scope.vm.monthSelected, year);
        }
    }

    // Format year value from select list
    function setYear(newValue, oldValue) {
        var year = '';
        if ($scope.vm.yearTypeSelected === 'Financial Year') {
            var year = newValue.substring(7, 11);
        } else {
            year = newValue;
        }

        if (oldValue) {
            setDates($scope.vm.monthSelected, year);
        }
    }

    // Format month value from select list
    function setMonth(newValue, oldValue) {
        var year = '';
        if ($scope.vm.yearTypeSelected === 'Financial Year') {
            year = $scope.vm.yearSelected.toString().substring(7, 11);
        } else {
            year = $scope.vm.yearSelected.toString();
        }

        if (oldValue) {
            setDates(newValue, year);
        }
    }

    // Set the start and end dates for data queries
    function setDates(month, year) {
        if (month === 'All months') {
            if ($scope.vm.yearTypeSelected === 'Financial Year') {
                $scope.vm.startDate = moment('01/07/' + year, 'DD/MM/YYYY').subtract(1, 'year').format('DD/MM/YYYY');
                $scope.vm.endDate = moment('30/06/' + year, 'DD/MM/YYYY').format('DD/MM/YYYY');
            } else {
                $scope.vm.startDate = moment('01/01/' + year, 'DD/MM/YYYY').format('DD/MM/YYYY');
                $scope.vm.endDate = moment('31/12/' + year, 'DD/MM/YYYY').format('DD/MM/YYYY');
            }
        } else {
            // Create Moment object from month and year
            var monthYearMoment = moment(month + '/' + year, 'MMMM/YYYY');

            if (monthYearMoment.format('M') >= 7 && $scope.vm.yearTypeSelected === 'Financial Year') {
                $scope.vm.startDate = moment(monthYearMoment).subtract(1, 'year').startOf('month').format('DD/MM/YYYY');
                $scope.vm.endDate = moment(monthYearMoment).subtract(1, 'year').endOf('month').format('DD/MM/YYYY');
            } else {
                $scope.vm.startDate = moment(monthYearMoment).startOf('month').format('DD/MM/YYYY');
                $scope.vm.endDate = moment(monthYearMoment).endOf('month').format('DD/MM/YYYY');
            }
        }

        // Request new dataset
        $scope.vm.changeData();
        // Update displayed dates
        $scope.vm.startDateDisplay = moment($scope.vm.startDate, 'DD/MM/YYYY').format('DD MMMM YYYY');
        $scope.vm.endDateDisplay = moment($scope.vm.endDate, 'DD/MM/YYYY').format('DD MMMM YYYY');
    }

    // Print only the elements encapsulated by id="print", set dimensions as appropriate for A4 landscape
    function printPage() {
        var documentHead = document.head.outerHTML,
            contentToPrint = document.getElementById('print').outerHTML,
            windowSpecs = 'height=792, width=1124, menubar=no, statusbar=no, titlebar=no',
            printWindow = window.open('', '_blank', windowSpecs),
            printEvent = printWindow.matchMedia('print');

        printWindow.document.open();
        printWindow.document.write('<!doctype html><html>' + documentHead + '<body onLoad="window.print()">' + contentToPrint + '</body></html>');
        printWindow.document.close();

        // Close the print window once the print dialog box closes
        printEvent.addListener(function (printEnd) {
            if (!printEnd.matches) {
                printWindow.close();
            }
        });
    }

    // Add or remove page elements to be printed
    function togglePrint() {
        if ($scope.vm.printByMonthDt) {
            $('#byMonthDtContainer').removeClass('no-print');
        } else {
            $('#byMonthDtContainer').addClass('no-print');
        }

        if ($scope.vm.printBySpecialtyDt) {
            $('#bySpecialtyDtContainer').removeClass('no-print');
        } else {
            $('#bySpecialtyDtContainer').addClass('no-print');
        }

        if ($scope.vm.printCriteriaSummaryDt) {
            $('#criteriaSummaryDtContainer').removeClass('no-print');
        } else {
            $('#criteriaSummaryDtContainer').addClass('no-print');
        }

        if ($scope.vm.printAuditTypeSummaryDt) {
            $('#auditTypeSummaryDtContainer').removeClass('no-print');
        } else {
            $('#auditTypeSummaryDtContainer').addClass('no-print');
        }

        if ($scope.vm.printWiesByMonthTable) {
            $('#table__wiesByMonth').removeClass('no-print');
        } else {
            $('#table__wiesByMonth').addClass('no-print');
        }

        if ($scope.vm.printWiesByMonthChart) {
            $('#chart__wiesByMonth').removeClass('no-print');
        } else {
            $('#chart__wiesByMonth').addClass('no-print');
        }

        // Only print section if one or more of its elements is to be printed
        if (!$scope.vm.printWiesByMonthTable && !$scope.vm.printWiesByMonthChart) {
            $('#wiesByMonth').addClass('no-print');
        } else {
            $('#wiesByMonth').removeClass('no-print');
        }

        if ($scope.vm.printWiesBySpecialtyTable) {
            $('#table__wiesBySpecialty').removeClass('no-print');
        } else {
            $('#table__wiesBySpecialty').addClass('no-print');
        }

        if ($scope.vm.printWiesBySpecialtyChart) {
            $('#chart__wiesBySpecialty').removeClass('no-print');
        } else {
            $('#chart__wiesBySpecialty').addClass('no-print');
        }

        // Only print section if one or more of its elements is to be printed
        if (!$scope.vm.printWiesBySpecialtyTable && !$scope.vm.printWiesBySpecialtyChart) {
            $('#wiesBySpecialty').addClass('no-print');
        } else {
            $('#wiesBySpecialty').removeClass('no-print');
        }
    }

    // Show or hide columns according to select list
    function toggleColumns(datatable) {

        var table = $('#' + datatable).DataTable(),
            colsToHide = [],
            colsToShow = [];

        if (datatable === 'byMonthDt') {
            // Iterate through available columns
            angular.forEach($scope.vm.byMonthDtColsOptions, function (value, key) {
                // If column is not in list of selected columns
                if ($filter('filter')($scope.vm.byMonthDtColsSelected, value, true).length === 0) {
                    // Add to array of column indexes to hide
                    colsToHide.push(key);
                    // Hide the corresponding footer cell
                    $('#' + datatable + ' .group-footer td:nth-child(' + (key + 1) + ')').hide();
                    // If column is in list of selected columns
                } else {
                    // Add to array of column indexes to show
                    colsToShow.push(key);
                    // Show the corresponding footer cell
                    $('#' + datatable + ' .group-footer td:nth-child(' + (key + 1) + ')').show();
                }
            });
        }

        if (datatable === 'bySpecialtyDt') {
            angular.forEach($scope.vm.bySpecialtyDtColsOptions, function (value, key) {
                if ($filter('filter')($scope.vm.bySpecialtyDtColsSelected, value, true).length === 0) {
                    colsToHide.push(key + 1);
                    $('#' + datatable + ' .group-footer td:nth-child(' + (key + 1) + '), .grand-footer td:nth-child(' + (key + 1) + ')').hide();
                } else {
                    colsToShow.push(key + 1);
                    $('#' + datatable + ' .group-footer td:nth-child(' + (key + 1) + '), .grand-footer td:nth-child(' + (key + 1) + ')').show();
                }
            });
        }

        if (datatable === 'criteriaSummaryDt') {
            angular.forEach($scope.vm.criteriaSummaryDtColsOptions, function (value, key) {
                if ($filter('filter')($scope.vm.criteriaSummaryDtColsSelected, value, true).length === 0) {
                    colsToHide.push(key);
                } else {
                    colsToShow.push(key);
                }
            });
        }

        if (datatable === 'auditTypeSummaryDt') {
            angular.forEach($scope.vm.auditTypeSummaryDtColsOptions, function (value, key) {
                if ($filter('filter')($scope.vm.auditTypeSummaryDtColsSelected, value, true).length === 0) {
                    colsToHide.push(key);
                } else {
                    colsToShow.push(key);
                }
            });
        }

        // Hide/show columns
        table.columns(colsToHide).visible(false, false);
        table.columns(colsToShow).visible(true, true);
        // Adjust group header colspan to match number of visible columns
        $('#' + datatable + ' .group-header td').attr('colspan', $scope.vm.bySpecialtyDtColsOptions.length - colsToHide.length);
        // Ensure correct padding on last cells when last column hidden
        $('#' + datatable + ' tr').find('td:visible:last').css('padding-right', '24px', 'important');
    }
};

exports.default = ExecutivesummaryController;


// WEBPACK FOOTER //
// ./client/app/common/reports/executivesummary/executivesummary.controller.js